import { SVGProps } from 'react';
import { SvgSymbolIds } from '../constants';
export function IconArrowRight(props: SVGProps<SVGSVGElement>) {
  return <svg {...props} data-sentry-element="svg" data-sentry-component="IconArrowRight" data-sentry-source-file="arrow-right.tsx">
            <use href={`#${SvgSymbolIds.ArrowRight}`} data-sentry-element="use" data-sentry-source-file="arrow-right.tsx" />
        </svg>;
}